// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__190-e","question":"Question_question__3ZMWT","description":"Question_description__3hyM2"};